export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f76245161fad859a478a5d6f77d324279a2c45287&name=fetchTypeahead!'